// extracted by mini-css-extract-plugin
module.exports = {"userIndicator":"userIndicator__1ll7h","username":"username__nLFL1","miniAvatar":"miniAvatar__3jTQY","arrow":"arrow__2aJgQ","dropdown":"dropdown__3BGSd"};